import React from 'react';
import { Button } from 'react-bootstrap';
import './SchemeSelectButton.scss';

const SchemeSelectButton = ({ handleToggleScheme, isSelected }) => (
  <Button
    // className={cx('scheme-select-button', {
    //     'scheme-select-button--not-selected':  hasSchemesSelected && !isSelected,
    //     'scheme-select-button--selected': hasSchemesSelected && isSelected,
    //
    // })}
    onClick={handleToggleScheme}
    block
    bsStyle="primary"
  >
    {isSelected ? 'Selected' : 'Select'}
  </Button>
);
export default SchemeSelectButton;
